import React from 'react'
import { Button, type ButtonSizeValue } from '@mc/design-system'
import { EnhancedCtaCopy, usePrimaryCta } from '@mc/growth'
import { trackCtaClicked } from '../../lib/events'

interface SignUpButtonProps {
  className?: string
  size?: ButtonSizeValue
  fullWidth?: boolean
  location: string
  pageSource?: string
  href: string
}

export const SignUpButton = ({
  className = '',
  size = 'md',
  fullWidth = false,
  location,
  pageSource,
  href,
}: SignUpButtonProps) => {
  const { ctaCopy } = usePrimaryCta()

  return (
    <Button
      fullWidth={fullWidth}
      className={className}
      onClick={() => {
        trackCtaClicked({ action: ctaCopy, location, pageSource, href })
      }}
      as='a'
      href={href}
      size={size}
    >
      <EnhancedCtaCopy>{ctaCopy}</EnhancedCtaCopy>
    </Button>
  )
}
